import { FunctionComponent, Suspense, lazy } from 'react'

import { LoadingTurbo } from 'atoms'
import { useBreakpointValue } from 'native-base'

import { TabCommonProps } from './types'

const RegulatoryMobile = lazy(() => import('./mobile'))

const RegulatoryDesktop = lazy(() => import('./desktop'))

export const Regulatory: FunctionComponent<TabCommonProps> = (props) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  const Component = isMobile ? RegulatoryMobile : RegulatoryDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Component {...props} />
    </Suspense>
  )
}
